import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-admin-panel-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './admin-panel-layout.component.html',
  styleUrls: ['./admin-panel-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminPanelLayoutComponent {

}
